// Styles
import { halfCardGap } from "../BoardViewCommon.styles";
/**
 * Helper to get styles for TaskBoardCard
 */ export const getStyles = ({ isDragging })=>{
    const root = [
        "taskBoardCard",
        {
            margin: `${halfCardGap} 0px`,
            position: "relative",
            width: "100%",
            display: isDragging ? "none" : ""
        }
    ];
    return {
        root
    };
};
